// The tenant id will be saved in the session storage
import { getCookie } from '../utils/cookies';
import { teamIdCookie } from '../types/authenticationContext.types';
export const tenantIdKey = 'tenantId';
export function getTenantId() {
    const tenantId = sessionStorage.getItem('tenantId') || undefined;
    return tenantId;
}
export const setTenantId = (tenantId) => {
    if (!tenantId) {
        return window.sessionStorage.removeItem('tenantId');
    }
    window.sessionStorage.setItem('tenantId', tenantId);
    window.localStorage.setItem('tenantId', tenantId);
};
export const clearAllTenantIdStorages = () => {
    window.sessionStorage.removeItem('tenantId');
    window.localStorage.removeItem('tenantId');
};
export const getTenantIdCookie = () => {
    return getCookie(teamIdCookie);
};
